import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from "@mui/styles";

import { ConfirmCancelDialog } from "../ConfirmCancelDialog";
import { LanguageContext } from '../LanguageContext';

const defaultToolbarStyles = {
    iconButton: {
    },
};
var iniSales;
var iniProduct;

class OffersEdit extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        var data = props.Daatta.filter(function (d) {
            return d.offersId === props.rowId;
        });

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            data: data,
            OffersId: data[0].offersId,
            Name: data[0].name,
            Description: data[0].description,
            Sales_Id: data[0].sales_Id,
            Product_Id: data[0].product_Id,
            Price: data[0].price,
            Discount: data[0].discount,
            Unit: data[0].unit,
            ExternalLink: data[0].externalLink,
            Modifier: data[0].modifier,
            StartTime: data[0].startTime,
            EndTime: data[0].endTime,
            sales: (Object.keys(props.lookupLists.sales).map((d) => ({ value: d, label: props.lookupLists.sales[d] })) || []),
            product: (Object.keys(props.lookupLists.product).map((d) => ({ value: d, label: props.lookupLists.product[d] })) || []),
        };

    }

    UNSAFE_componentWillMount() {
        iniSales = this.state.sales.find(({ value }) => value === (this.state.Sales_Id || '').toString());
        iniProduct = this.state.product.find(({ value }) => value === (this.state.Product_Id || '').toString());
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            OffersId: this.state.data[0].offersId,
            Name: this.state.data[0].name,
            Description: this.state.data[0].description,
            Sales_Id: this.state.data[0].sales_Id,
            Product_Id: this.state.data[0].product_Id,
            Price: this.state.data[0].price,
            Discount: this.state.data[0].discount,
            Unit: this.state.data[0].unit,
            ExternalLink: this.state.data[0].externalLink,
            Modifier: this.state.data[0].modifier,
            StartTime: this.state.data[0].startTime,
            EndTime: this.state.data[0].endTime
        });
    }

    handleSave = () => {
        this.props.onEditRow({
            LocationId: this.state.LocationId,
            Name: this.state.Name,
            Description: this.state.Description,
            Sales_Id: this.state.Sales_Id,
            Product_Id: this.state.Product_Id,
            Price: this.state.Price,
            Discount: this.state.Discount,
            Unit: this.state.Unit,
            ExternalLink: this.state.ExternalLink,
            Modifier: this.state.Modifier,
            StartTime: this.state.StartTime,
            EndTime: this.state.EndTime
        });

        this.handleClearData();
    }

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({ [item]: newValue.value })
        }
        else {
            this.setState({ [item]: null })
        }
        this.setState({ jotainMuuttui: true })
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    render() {
        const { dictionary } = this.context;
        const { open, sales, product } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.Edit}>
                    <IconButton onClick={this.handleClickOpen}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.Offers.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.Offers.Columns[1]}
                            type="text"
                            fullWidth
                            value={this.state.Name}
                            onChange={this.handleChange('Name')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Offers.Columns[2]}
                            type="text"
                            fullWidth
                            value={this.state.Description}
                            onChange={this.handleChange('Description')}
                        />
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                defaultValue={iniSales}
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'Sales_Id')}
                                options={sales}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Offers.Columns[3]} />}
                            />
                        </Box>
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                defaultValue={iniProduct}
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'Product_Id')}
                                options={product}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Offers.Columns[4]} />}
                            />
                        </Box>
                        <TextField
                            margin="dense"
                            label={dictionary.Offers.Columns[5]}
                            type="text"
                            fullWidth
                            value={this.state.Price}
                            onChange={this.handleChange('Price')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Offers.Columns[6]}
                            type="text"
                            fullWidth
                            value={this.state.Discount}
                            onChange={this.handleChange('Discount')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Offers.Columns[7]}
                            type="text"
                            fullWidth
                            value={this.state.Unit}
                            onChange={this.handleChange('Unit')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Offers.Columns[8]}
                            type="text"
                            fullWidth
                            value={this.state.ExternalLink}
                            onChange={this.handleChange('ExternalLink')}
                        />

                        
                    </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />

            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "OffersEdit" })(OffersEdit);
